module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+MDA4ODU2OEItQTFCMi00MjZDLTgzQTUtQjRCMTZGMjUyNjVCPC90aXRsZT48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogIDxwYXRoIG9wYWNpdHk9IjAuNTAiIGQ9Ik0xOSAzSDVjLTEuMSAwLTIgLjktMiAydjE0YzAgMS4xLjkgMiAyIDJoMTRjMS4xIDAgMi0uOSAyLTJWNWMwLTEuMS0uOS0yLTItMnptLTkgMTRsLTUtNC44MDggMS40LTEuMzQ2IDMuNiAzLjQ2MkwxNy42IDcgMTkgOC4zNDYgMTAgMTd6IiBmaWxsPSIjNDc4NmZmIi8+PC9nPjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ../ui-components/components/Checkbox/on-disabled.svg
// module id = 2236
// module chunks = 1